import { render, staticRenderFns } from "./downloadCorpusDialog.vue?vue&type=template&id=53ad14be&scoped=true&"
import script from "./downloadCorpusDialog.vue?vue&type=script&lang=js&"
export * from "./downloadCorpusDialog.vue?vue&type=script&lang=js&"
import style0 from "./downloadCorpusDialog.vue?vue&type=style&index=0&id=53ad14be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ad14be",
  null
  
)

export default component.exports